import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { EditorModule } from 'primeng/editor';

import { AngularMyDatePickerModule } from '../common/legacy-lib/angular-mydatepicker/angular-mydatepicker.module';
import { ButtonComponent } from '../common/components/button/button.component';
import { FmFooterComponent } from '../fannie-mae-cdx-components/fm-footer/fm-footer.component';
import { TextLengthLimitationDirective } from '../shared/directives/text-length-limitation.directive';
import { SharedModule } from '../shared/shared.module';
import { AvailableRcrTakedownListingsComponent } from './available-rcr-takedowns-container/available-rcr-takedown-listings/available-rcr-takedown-listings.component';
import { AvailableRcrTakedownsComponent } from './available-rcr-takedowns-container/available-rcr-takedowns.component';
import { CommitExchangeTableComponent } from './commit-exchange-table/commit-exchange-table';
import { CommittedExchangesContainerComponent } from './committed-exchanges-container/committed-exchanges-container.component';
import { CommittedExchangesListingsComponent } from './committed-exchanges-container/committed-exchanges-listings/committed-exchanges-listings.component';
import { ConfirmationComponent } from './confirmation-page/confirmation-page';
import { EnterBalancesInterestReviewErrorComponent } from './enter-balances/enter-balances-interest-review-error/enter-balances-interest-review-error.component';
import { RcrExchangeErrorComponent } from './enter-balances/enter-balances-rcr-exchange-error/rcr-exchange-error.component';
import { EnterBalancesRecombinationsTableRowComponent } from './enter-balances/enter-balances-recombinations-table-row/enter-balances-recombinations-table-row.component';
import { EnterBalancesRecombinationsTableComponent } from './enter-balances/enter-balances-recombinations-table/recombinations-table.component';
import { EnterBalancesComponent } from './enter-balances/enter-balances.component';
import { RcrExchangeContainerComponent } from './rcr-exchange-container/rcr-exchange-container.component';
import { RcrExchangeErrorMessageComponent } from './rcr-exchange-container/rcr-exchange-error/rcr-exchange-error';
import { RCRExchangeRoutingModule } from './rcr-exchange-routing.module';
import { ContactListComponent } from './reports/contact-list/contact-list.component';
import { RcrVolumeReportComponent } from './reports/rcr-volume-report/rcr-volume-report.component';
import { ValidateArmPoolComponent } from './reports/validate-arm-pool/validate-arm-pool.component';
import { JumegaReportComponent } from './reports/jumega-report/jumega-report.component';
import { FmInputWithValidationsForRequestAnExchangeComponent } from './request-an-exchange-lookup/fm-input-with-validations-for-request-an-exchange/fm-input-with-validations-for-request-an-exchange.component';
import { RequestAnExchangeLookupComponent } from './request-an-exchange-lookup/request-an-exchange-lookup.component';
import { CancelExchangeConfirmationComponent } from './review-and-commit/cancel-Exchange-Confirmation/cancel-exchange-confirmation';
import { ReviewAndCommitComponent } from './review-and-commit/review-and-commit.component';
import { CancelExchangeService } from './services/cancel-exchange.service';
import { CommittedExchangeService } from './services/committed-exchange.service';
import { EnterBalancesValidationServiceService } from './services/enter-balances-validation-service.service';
import { RcrExchangeNavigationServiceService } from './services/rcr-exchange-navigation-service.service';
import { RecombinationsService } from './services/recombinations.service';
import { SettledExchangesContainerComponent } from './settled-exchanges-container/settled-exchanges-container.component';
import { SettledExchangesListingsComponent } from './settled-exchanges-container/settled-exchanges-listings/settled-exchanges-listings.component';
import { DateSelectedService } from './shared/date-selected.service';
import { StickyInputToolbarComponent } from './shared/sticky-input-toolbar/sticky-input-toolbar.component';
import { RcrExchangeStickyFooterComponent } from './shared/sticky-toolbar/rcr-exchange-footer.component';
import { SmbsExchangeExpandableComponent } from './smbs-exchange/smbs-exchange-expandable/smbs-exchange-expandable.component';
import { SmbsExchangeTableComponent } from './smbs-exchange/smbs-exchange-expandable/smbs-exchange-table/smbs-exchange-table.component';
import { PricingFileUploadComponent } from './stpricingupload/pricing-file-upload/pricing-file-upload.component';
import { UpdateBannerComponent } from './update-banner/update-banner.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMyDatePickerModule,
    // FmComponentsModule,
    NgxPaginationModule,
    RCRExchangeRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    EditorModule,
    ButtonComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ConfirmationComponent,
    EnterBalancesComponent,
    EnterBalancesRecombinationsTableComponent,
    EnterBalancesRecombinationsTableRowComponent,
    RcrExchangeContainerComponent,
    RcrExchangeStickyFooterComponent,
    ReviewAndCommitComponent,
    SmbsExchangeExpandableComponent,
    RcrExchangeErrorComponent,
    StickyInputToolbarComponent,
    SmbsExchangeTableComponent,
    EnterBalancesInterestReviewErrorComponent,
    SettledExchangesContainerComponent,
    AvailableRcrTakedownsComponent,
    AvailableRcrTakedownListingsComponent,
    RcrExchangeErrorMessageComponent,
    CancelExchangeConfirmationComponent,
    TextLengthLimitationDirective,
    CommitExchangeTableComponent,
    FmFooterComponent,
    CommittedExchangesContainerComponent,
    CommittedExchangesListingsComponent,
    SettledExchangesListingsComponent,
    RequestAnExchangeLookupComponent,
    FmInputWithValidationsForRequestAnExchangeComponent,
    RcrVolumeReportComponent,
    ContactListComponent,
    ValidateArmPoolComponent,
    JumegaReportComponent,
    PricingFileUploadComponent,
    UpdateBannerComponent,
  ],
  providers: [
    provideHttpClient(),
    CancelExchangeService,
    CommittedExchangeService,
    DateSelectedService,
    RcrExchangeNavigationServiceService,
    EnterBalancesValidationServiceService,
    RecombinationsService,
  ],
})
export class RCRExchangeModule {}
